import { useFlowQuery } from '@twisto/api-graphql'
import { Loader } from '@twisto/components/atoms/loader'
import { useRedirect } from '@twisto/nextjs/utils'

import { useFlow } from '../../flow/flow.context'

export const RedirectStep = () => {
  const { sessionId, actions } = useFlow()
  const redirect = useRedirect()
  const { handleClose } = actions

  useFlowQuery({
    variables: {
      auth: {
        sessionId,
      },
    },
    onCompleted: async (data) => {
      if (
        data.flow?.currentStep.__typename === 'BaseRedirectStep' ||
        data.flow?.currentStep.__typename === 'VeriffRedirectStep' ||
        data.flow?.currentStep.__typename === 'SaltEdgeRedirectStep' ||
        data.flow?.currentStep.__typename === 'WebViewRedirectStep'
      ) {
        const { url } = data.flow.currentStep

        // If the redirect is to the same page, close the modal
        if (url === window.location.href) {
          return handleClose?.()
        }

        await redirect(url)
      }
    },
  })

  return <Loader />
}
